import { Box, Button, Stack, Typography } from '@mui/material'

import { ErrorPageHeader } from '../ErrorPageHeader'
import { ErrorPageLayout } from '../ErrorPageLayout'
import { ErrorGenericImage } from './ErrorGenericImage'

import { useTexts } from './useTexts'

export function GenericErrorPage() {
  const texts = useTexts()

  return (
    <ErrorPageLayout header={<ErrorPageHeader />}>
      <Stack direction="column" spacing={3} textAlign="center" alignItems="center">
        <Box>
          <ErrorGenericImage />
        </Box>
        <Stack direction="column" spacing={1}>
          <Typography variant="h6">{texts.title}</Typography>
          <Typography variant="body2">{texts.description}</Typography>
        </Stack>
        <Stack direction="row">
          <Button variant="contained" onClick={() => (window.location.href = '/')}>
            {texts.primaryAction}
          </Button>
        </Stack>
      </Stack>
    </ErrorPageLayout>
  )
}
